export const monospacePreStyles = {
  margin: 0,
  padding: '12px',
  overflow: 'auto',
  maxHeight: 320,
  borderRadius: '4px',
  fontSize: '12px',
  fontFamily: 'monospace',
  backgroundColor: ({ palette }) => palette.background.secondary,
  color: ({ palette }) => palette.text.primary,
  border: ({ palette }) => `1px solid ${palette.divider}`,
  whiteSpace: 'pre-wrap',
  wordBreak: 'break-all',
};
